// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._2rkoyh40{border-radius:2px}._154i1ssb{top:50%}
._1bsb7vkz{width:1pc}
._1ltv1ssb{left:50%}
._2hwx1b66{margin-right:var(--ds-space-050,4px)}
._4t3i7vkz{height:1pc}
._kqswstnw{position:absolute}
._t9ec1ooe{transform:translate(-50%,-50%)}
._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/InlineCard/Icon.compiled.css"],"names":[],"mappings":";AACA,WAAW,iBAAiB,CAAC,WAAW,OAAO;AAC/C,WAAW,SAAS;AACpB,WAAW,QAAQ;AACnB,WAAW,oCAAoC;AAC/C,WAAW,UAAU;AACrB,WAAW,iBAAiB;AAC5B,WAAW,8BAA8B;AACzC,WAAW,wBAAwB,CAAC,oBAAoB,CAAC,gBAAgB","sourcesContent":["\n._2rkoyh40{border-radius:2px}._154i1ssb{top:50%}\n._1bsb7vkz{width:1pc}\n._1ltv1ssb{left:50%}\n._2hwx1b66{margin-right:var(--ds-space-050,4px)}\n._4t3i7vkz{height:1pc}\n._kqswstnw{position:absolute}\n._t9ec1ooe{transform:translate(-50%,-50%)}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
